<template>
  <div id="NSR-results-grid-view">
    <!-- TABLE ACTION ROW -->
    <div class="flex flex-wrap justify-between items-center">
      <!-- ITEMS PER PAGE -->
      <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
         <Pager
                  :currentPage="currentPage"
                  :itemsPerPage="paginationPageSize"
                  :totalCount="NSRResults.length"
                  :queriedItems="queriedItems"
                  :pageSizes="[20,50,100,150]"
                  @pageChanged="onPageChanged"
                ></Pager>
      </div>

      <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
      <div class="flex flex-wrap items-center justify-between ag-grid-table-actions-right">
        <vs-input
          class="mb-4 md:mb-0 mr-4"
          v-model="searchQuery"
          @input="updateSearchQuery"
          placeholder="Search..."
        />
      </div>
    </div>
    <ag-grid-vue
      ref="agGridTable"
      :gridOptions="gridOptions"
      class="ag-theme-material w-100 my-4 ag-grid-table"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      :rowData="NSRResults"
      rowSelection="multiple"
      colResizeDefault="shift"
      :animateRows="true"
      :floatingFilter="true"
      :pagination="true"
      :paginationPageSize="paginationPageSize"
      :suppressPaginationPanel="true"
      :enableRtl="$vs.rtl"
    ></ag-grid-vue>
    <vs-pagination :total="totalPages" :max="maxPageNumbers" v-model="currentPage" />
  </div>
</template>
<script>
import moduleNSR from "@/store/geo/NSR/moduleNSR.js";
import { CurrencyCell, Pager } from "../../../shared/components";
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";

export default {
  /* eslint-disable vue/no-unused-components */
  components: {
    AgGridVue,
    CurrencyCell,
    Pager
  },
  props: {
    scenarioId: {
      type: Number,
      default: () => {}
    }
  },
  data() {
    return {
      searchQuery: "",
      gridOptions: {},
      maxPageNumbers: 7,
      gridApi: null,
      defaultColDef: {
        sortable: true,
        editable: true,
        resizable: true,
        suppressMenu: true
      },
      columnDefs: [
        {
          headerName: "Block Model",
          children: [
            {
              headerName: "Zone",
              field: "zone",
              filter: true,
              width: 150,
              pinned: "left"
            },
            {
              headerName: "Tonnage",
              field: "tonnage",
              width: 150
            },
            {
              headerName: "NSR",
              field: "baseNSR",
              width: 150,
              cellRendererFramework: "CurrencyCell"
            },
            {
              headerName: "NSR / Ton",
              field: "baseNSRPerTon",
              width: 150,
              cellRendererFramework: "CurrencyCell"
            },
            {
              headerName: "Au Eq",
              field: "baseGoldEq",
              width: 150,
              cellRendererFramework: "CurrencyCell"
            }
          ]
        },
        {
          headerName: "Scenario",
          children: [
            {
              headerName: "NSR",
              field: "scenarioNSR",
              width: 200,
              cellRendererFramework: "CurrencyCell"
            },
            {
              headerName: "NSR / Ton",
              field: "scenarioNSRPerTon",
              width: 200,
              cellRendererFramework: "CurrencyCell"
            },
            {
              headerName: "Au Eq",
              field: "scenarioGoldEq",
              width: 200,
              cellRendererFramework: "CurrencyCell"
            }
          ]
        },
        {
          headerName: "Delta",
          children: [
            {
              headerName: "NSR",
              field: "deltaNSR",
              width: 200,
              cellRendererFramework: "CurrencyCell"
            },
            {
              headerName: "NSR / Ton",
              field: "deltaNSRPerTon",
              width: 200,
              cellRendererFramework: "CurrencyCell"
            },
            {
              headerName: "Au Eq",
              field: "deltaGoldEq",
              width: 200,
              cellRendererFramework: "CurrencyCell"
            }
          ]
        }
      ]
    };
  },
  computed: {
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 50;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      }
    },
    NSRResults() {
      return this.$store.state.nsr.nsrResults;
    },
    queriedItems() {
      return this.$refs.table
        ? this.$refs.table.queriedResults.length
        : this.NSRResults.length;
    }
  },
  methods: {
    queryNSR() {
      this.$store
        .dispatch("nsr/getNsrQuery", this.$props.scenarioId)
        .then(this.$emit("onNSRRefreshedSelected"));
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },
    onPageChanged(val) {
      this.gridApi.paginationSetPageSize(val)
    }
  },
  created() {
    if (!moduleNSR.isRegistered) {
      this.$store.registerModule("nsr", moduleNSR);
      moduleNSR.isRegistered = true;
    }
  },
  mounted() {
    this.gridApi = this.gridOptions.api;

    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(
        ".ag-header-container"
      );
      header.style.left = `-${String(
        Number(header.style.transform.slice(11, -3)) + 9
      )}px`;
    }
  }
};
</script>
<style lang="scss">
#NSR-results-grid-view {
   .ag-header-group-text {
     text-align: center;
     border: 1px;
   }
   .ag-header-group-cell-label {
     align-content: center;
   }
}
  </style>
